// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KsHQ9v {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  overflow: hidden;
}

.PUcy0V {
  position: relative;
  flex: 1;
  min-height: 0;
  border: 1px solid var(--surface-neutral-soft);
  border-radius: 4px;
  overflow: hidden;
  background: var(--surface-neutral-pale);
  padding: 24px;
}

.IxV4nl {
  width: 100%;
  height: 100%;
  border: none;
  background: var(--surface-neutral-white);
  border-radius: 0;
  font-family: var(--font-family-base);
  font-size: 12px;
  line-height: 1.87;
}

.pKt0eC {
  width: 100%;
  height: 100%;
  min-height: 200px;
  overflow: auto;
  background: var(--surface-neutral-white);
  font-family: var(--font-family-base);
  font-size: 12px;
  line-height: 1.87;
}

.cfhn0s {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--surface-neutral-light);
  z-index: 1;
}

.YDmdo4 {
  font-family: var(--font-family-base);
  font-size: var(--type-label-md-font-size);
  color: var(--text-neutral-medium);
}

.iyIDFe {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  text-align: center;
  background: var(--surface-neutral-light);
}

.wwdHdo {
  font-family: var(--font-family-base);
  font-size: var(--type-label-md-font-size);
  color: var(--status-error-dark);
  margin-top: 12px;
  text-align: center;
}

.z1yjQG {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-shrink: 0;
}

.spSNTZ {
  position: relative;
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--type-label-md-font-size);
  line-height: var(--type-label-md-line-height);
  color: var(--text-neutral-dark);
  gap: 12px;
  flex: 1;
  min-height: 24px;
}

.spSNTZ:has(.OdkVvC:disabled) {
  cursor: not-allowed;
  opacity: 0.6;
}

.spSNTZ:has(.OdkVvC:disabled) .hHG6zU {
  color: var(--text-neutral-medium);
}

.OdkVvC {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.OdkVvC:disabled {
  cursor: not-allowed;
}

.o9oelE {
  position: relative;
  height: 16px;
  width: 16px;
  background-color: transparent;
  border: 1px solid #666666;
  border-radius: 2px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.spSNTZ:hover .o9oelE {
  border-color: var(--surface-primary-medium);
}

.spSNTZ:has(.OdkVvC:disabled) .o9oelE {
  opacity: 0.5;
  cursor: not-allowed;
}

.spSNTZ:has(.OdkVvC:disabled):hover .o9oelE {
  border-color: #666666;
}

.OdkVvC:checked ~ .o9oelE {
  background-color: var(--surface-primary-medium);
  border-color: var(--surface-primary-medium);
}

.Li0RSU {
  width: 12px;
  height: 10px;
  object-fit: contain;
}

.hHG6zU {
  flex: 1;
  user-select: none;
}

.WfCzrJ {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-s);
  height: fit-content;
}

.pfFdsh {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-lg-font-size);
  font-weight: var(--type-paragraph-lg-regular-font-weight);
  line-height: var(--type-paragraph-lg-regular-line-height);
  color: var(--text-neutral-dark);
}

/* Loading layout migrated from ActivationFeedback */
.yJ487t {
  position: relative;
  flex: 1;
  min-height: 0;
  padding: var(--spacing-3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.E_W646 {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.Hns9Eg {
  background-color: #fff0e5;
}

.ly6KiX {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1rem;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.K9tH_l {
  font-size: 14px;
  color: #475569;
  margin-bottom: 0;
  line-height: 1.6;
  max-width: 380px;
}

@media (max-width: 768px) {
  .KsHQ9v {
    gap: 16px;
  }

  .PUcy0V {
    padding: 16px;
  }

  .z1yjQG {
    padding: 12px 0;
  }

  .spSNTZ {
    font-size: 13px;
    gap: 8px;
  }

  .o9oelE {
    height: 16px;
    width: 16px;
    border: 1px solid #666666;
    border-radius: 2px;
  }

  .Li0RSU {
    width: 12px;
    height: 10px;
  }

  .WfCzrJ {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HiringPage/components/HiringTerms/HiringTerms.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,wCAAwC;EACxC,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 100%;\n  overflow: hidden;\n}\n\n.contractContainer {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  border: 1px solid var(--surface-neutral-soft);\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--surface-neutral-pale);\n  padding: 24px;\n}\n\n.contractIframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: var(--surface-neutral-white);\n  border-radius: 0;\n  font-family: var(--font-family-base);\n  font-size: 12px;\n  line-height: 1.87;\n}\n\n.contractHtml {\n  width: 100%;\n  height: 100%;\n  min-height: 200px;\n  overflow: auto;\n  background: var(--surface-neutral-white);\n  font-family: var(--font-family-base);\n  font-size: 12px;\n  line-height: 1.87;\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column;\n  gap: 16px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--surface-neutral-light);\n  z-index: 1;\n}\n\n.loadingText {\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-md-font-size);\n  color: var(--text-neutral-medium);\n}\n\n.errorContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column;\n  gap: 16px;\n  padding: 24px;\n  text-align: center;\n  background: var(--surface-neutral-light);\n}\n\n.errorText {\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-md-font-size);\n  color: var(--status-error-dark);\n  margin-top: 12px;\n  text-align: center;\n}\n\n.termsAcceptance {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.checkboxContainer {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-md-font-size);\n  line-height: var(--type-label-md-line-height);\n  color: var(--text-neutral-dark);\n  gap: 12px;\n  flex: 1;\n  min-height: 24px;\n}\n\n.checkboxContainer:has(.checkbox:disabled) {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.checkboxContainer:has(.checkbox:disabled) .labelText {\n  color: var(--text-neutral-medium);\n}\n\n.checkbox {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n.checkbox:disabled {\n  cursor: not-allowed;\n}\n\n.checkmark {\n  position: relative;\n  height: 16px;\n  width: 16px;\n  background-color: transparent;\n  border: 1px solid #666666;\n  border-radius: 2px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.checkboxContainer:hover .checkmark {\n  border-color: var(--surface-primary-medium);\n}\n\n.checkboxContainer:has(.checkbox:disabled) .checkmark {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.checkboxContainer:has(.checkbox:disabled):hover .checkmark {\n  border-color: #666666;\n}\n\n.checkbox:checked ~ .checkmark {\n  background-color: var(--surface-primary-medium);\n  border-color: var(--surface-primary-medium);\n}\n\n.checkmarkIcon {\n  width: 12px;\n  height: 10px;\n  object-fit: contain;\n}\n\n.labelText {\n  flex: 1;\n  user-select: none;\n}\n\n.summaryCard {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 24px;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-s);\n  height: fit-content;\n}\n\n.summaryTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-lg-font-size);\n  font-weight: var(--type-paragraph-lg-regular-font-weight);\n  line-height: var(--type-paragraph-lg-regular-line-height);\n  color: var(--text-neutral-dark);\n}\n\n/* Loading layout migrated from ActivationFeedback */\n.loadingContent {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  padding: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.iconContainer {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n}\n\n.loadingIconContainer {\n  background-color: #fff0e5;\n}\n\n.loadingTitle {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1rem;\n  line-height: 1.3;\n  letter-spacing: -0.02em;\n}\n\n.loadingDescription {\n  font-size: 14px;\n  color: #475569;\n  margin-bottom: 0;\n  line-height: 1.6;\n  max-width: 380px;\n}\n\n@media (max-width: 768px) {\n  .stepContent {\n    gap: 16px;\n  }\n\n  .contractContainer {\n    padding: 16px;\n  }\n\n  .termsAcceptance {\n    padding: 12px 0;\n  }\n\n  .checkboxContainer {\n    font-size: 13px;\n    gap: 8px;\n  }\n\n  .checkmark {\n    height: 16px;\n    width: 16px;\n    border: 1px solid #666666;\n    border-radius: 2px;\n  }\n\n  .checkmarkIcon {\n    width: 12px;\n    height: 10px;\n  }\n\n  .summaryCard {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContent": `KsHQ9v`,
	"contractContainer": `PUcy0V`,
	"contractIframe": `IxV4nl`,
	"contractHtml": `pKt0eC`,
	"loadingContainer": `cfhn0s`,
	"loadingText": `YDmdo4`,
	"errorContainer": `iyIDFe`,
	"errorText": `wwdHdo`,
	"termsAcceptance": `z1yjQG`,
	"checkboxContainer": `spSNTZ`,
	"checkbox": `OdkVvC`,
	"labelText": `hHG6zU`,
	"checkmark": `o9oelE`,
	"checkmarkIcon": `Li0RSU`,
	"summaryCard": `WfCzrJ`,
	"summaryTitle": `pfFdsh`,
	"loadingContent": `yJ487t`,
	"iconContainer": `E_W646`,
	"loadingIconContainer": `Hns9Eg`,
	"loadingTitle": `ly6KiX`,
	"loadingDescription": `K9tH_l`
};
module.exports = ___CSS_LOADER_EXPORT___;
